
<template>
  <div class="cashTransactions">
      <div class="main">
          <div class="top-search">
              <div class="item"><span>商户名称：</span><div><el-select v-model="capitalValue" placeholder="请选择">
                    <el-option
                    v-for="item in CompanyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select></div></div>
              <div class="item"><span>发票申请编号：</span><div><el-input v-model="invoiceApplyNoInput" placeholder="单行输入"></el-input></div></div>
              <div class="item"><span>收支类型：</span><div><el-select v-model="PaymentVal" placeholder="请选择">
                    <el-option
                    v-for="item in PaymentData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select></div>
              </div>
              <div class="item"><span>业务类型：</span><div><el-select v-model="BusinessVal" placeholder="请选择">
                    <el-option
                    v-for="item in BusinessData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select></div>
              </div>
              <div class="item"><span>创建时间：</span>
                <div>
                  <el-date-picker
                    v-model="merchantsTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
              </div>
              <div class="item"><span style="width: 50px;"></span><el-button type="primary" @click="merchantsSearch">搜索</el-button> <el-button type="danger" @click="merchantsReset">重置</el-button></div>
          </div>
          <!-- <div class="middle-button"><el-button type="primary" plain>下载列表</el-button></div> -->
          <div class="bottom-table">
            <el-table
                :data="capitaltableData"
                border
                height="616"
                style="width: 100%">
                <el-table-column
                prop="merchant_id"
                label="商户ID">
                </el-table-column>
                <el-table-column
                prop="merchantName"
                label="商户名称">
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票申请编号">
                </el-table-column>
                <el-table-column
                prop="type"
                label="收支类型">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type == 1">充值</div>
                    <div v-if="scope.row.type == 2">支出</div>
                  </template>
                </el-table-column>
                <el-table-column
                prop="businessTypeName"
                label="业务类型">
                </el-table-column>
                <el-table-column
                prop="created_at"
                label="创建时间">
                </el-table-column>
                <el-table-column
                prop="amt_y"
                label="金额（元）">
                </el-table-column>
                <el-table-column
                prop="balance"
                label="账户结余金额（元）">
                </el-table-column>
            </el-table>
          </div>
          <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
          </div>
      </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
export default {
  data() {
    return {
      capitalValue:'',
      CompanyOptions: [],
      PaymentVal: '',
      PaymentData: [
          {
          value: '1',
          label: '充值'
          }, {
          value: '2',
          label: '支出'
          }
      ],
      invoiceApplyNoInput:'',
      capitaltableData: [],
      BusinessVal: '',
      BusinessData: [],
      total: null,
      merchantsTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    this.CompanyOptions = JSON.parse(localStorage.getItem('nameList')) || []
    this.tradeListPost()
  },
  methods: {
    currentChange(size) {
      console.log(size)
      this.tradeListPost(size)
    },
    // 重置
    merchantsReset() {
      this.capitalValue = ''
      this.invoiceApplyNoInput = ''
      this.PaymentVal = ''
      this.merchantsTime = [
        '',''
      ]
      this.tradeListPost()
    },
    // 搜索
    merchantsSearch() {
      if (this.merchantsTime.length == 0 ) {
        console.log('空的')
        this.merchantsTime = [
          '',''
        ]
      }
      console.log(this.merchantsTime)
      this.tradeListPost()
    },
    tradeListPost(size) {
      post(api.tradeList, {
        currentPage: size || 1,
        pageSize: 10,
        merchantId: this.capitalValue,
        invoiceApplyNo: this.invoiceApplyNoInput,
        type: this.PaymentVal,
        createdBegin: this.merchantsTime[0],
        createdEnd: this.merchantsTime[1]
      })
      .then((d) => {
        console.log(d.status)
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.total = d.data.count
          this.capitaltableData = d.data.rows
        }
      }, (err) => {
          //error callback
      })
    },
    handleClick(row) {
      console.log(row);
    }
  },
  components: {

  }
}
</script>

<style lang="less" scoped>
.cashTransactions {
    width: 100%;
    padding: 22px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .main {
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .top-search {
            width: 100%;
            overflow: hidden;
            .item {
                height: 46px;
                line-height: 46px;
                float: left;
                margin-bottom: 10px;
                span {
                    display: inline-block;
                    width: 115px;
                    font-size:14px;
                    font-family:PingFangSC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    text-align: right;
                    margin-right: 10px;
                }
                div {
                    display: inline-block;
                    width:233px;
                    height:46px;
                }
            }
        }
        .middle-button {
            width: 100%;
            text-align: left;
            padding-top: 10px;
        }
        .bottom-table {
            width: 100%;
            margin-top: 20px;
        }
        .bottom-pag {
            width: 100%;
            margin-top: 20px;
        }
    }
    .details {
      .title {
        width: 100%;
        height: 52px;
        line-height: 52px;
        .fanhui {
          float: left;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(102,102,102,1);
          position: relative;
          cursor: pointer;
        }
        .fanhui:after {
          content: '';
          position: absolute;
          top: 20px;
          right: -16px;
          width: 1px;
          height: 13px;
          background-color: #979797;
        }
        .qianyue {
          float: left;
          margin-left: 24px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:500;
          color:rgba(51,51,51,1);
        }
      }
      .content {
        width: 100%;
        .name {
          width: 100%;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:600;
          color:rgba(51,51,51,1);
          text-align: left;
          padding-left: 10px;
          box-sizing: border-box;
        }
        .box {
          margin-top: 10px;
          width: 100%;
          padding: 30px 10px;
          box-sizing: border-box;
          background:rgba(250,250,250,1);
          border-radius:6px;
          text-align: left;
          span {
            display: inline-block;
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin: 0px 55px;
            line-height: 36px;
          }
        }
        .box1 {
          margin-top: 10px;
          width: 100%;
          padding: 30px 10px;
          box-sizing: border-box;;
          border-radius:6px;
          text-align: left;
          overflow: hidden;
          .item {
            float: left;
            height:93px;
            margin-right: 100px;
            margin-bottom: 20px;
            div {
              float: left;
              min-width: 55px;
              height: 93px;
            }
            .picture {
              width:167px;
              height:93px;
              background:rgba(246,246,246,1);
              border-radius:8px;
              border:1px solid rgba(198,198,198,1);
            }
          }
          
        }
      }
    }
}
</style>

<style >
.el-select .el-input .el-select__caret {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/financial/money/cashTransactions.vue